import React from "react";
import { useTranslation } from "react-i18next";

const TableLabels = ({ showMarketers = true }) => {
  const [_] = useTranslation("global");

  return (
    <tr className="pickup-table-header">
      <th className="text-center">{_("panel.product")}</th>
      <th className="text-center">{_("panel.totalorders")}</th>
      <th className="text-center">{_("panel.quantity")}</th>
      <th className="text-center">{_("panel.quantityWarehouse")}</th>
      <th className="text-center">{_("panel.leftAfterPick")}</th>
      {showMarketers && <th className="text-center">{_("panel.themarketer")}</th>}
      <th className="text-center">{_("panel.theseller")}</th>
    </tr>
  );
};

export default TableLabels;
